import { RouteInfo } from "./sidebar.metadata";

/* Sidebar menu Routes and data 8*/
export const ROUTES: RouteInfo[] = [
  {
    path: "dashboard",
    title: "Dashboard",
    icon: "ft-grid",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "usermanager",
    title: "Users",
    icon: "ft-users",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "otplist",
    title: "Otp List",
    icon: "ft-unlock",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "shareholder",
    title: "Shareholder",
    icon: "ft-pie-chart",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "shareholder/list",
        title: "Shareholders",
        icon: "ft-users",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "shareholder/history",
        title: "Share History",
        icon: "ft-clock",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "gift-money",
    title: "Gift Money",
    icon: "ft-award",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "gift-money/settings",
        title: "Settings",
        icon: "ft-settings",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gift-money/history",
        title: "History",
        icon: "ft-clock",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "gfire",
    title: "GFire",
    icon: "ft-alert-triangle",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "gfire/admins/master-admin",
        title: "Master Admin",
        icon: "ft-shield",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gfire/admins/super-admin",
        title: "Super Admin",
        icon: "ft-users",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gfire/admins/admin",
        title: "Admin",
        icon: "ft-user",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gfire/complex-approvals",
        title: "Complex",
        icon: "ft-check-square",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gfire/shops",
        title: "Shops",
        icon: "ft-shopping-cart",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gfire/plans",
        title: "Plans",
        icon: "ft-package",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "getsuperagent",
    title: "Super Agents",
    icon: "ft-users",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "getsuperagent",
        title: "Super Agents",
        icon: "ft-users",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "agents",
        title: "Agents",
        icon: "ft-users",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "merchant",
    title: "Merchant",
    icon: "ft-briefcase",
    class: "has-sub",
    badge: "",
    badgeClass: "",
    isExternalLink: false,
    submenu: [
      {
        path: "merchants",
        title: "Merchants",
        icon: "ft-users",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "merchant-commission",
        title: "Commission Settings",
        icon: "ft-percent",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "merchant-transactions",
        title: "Transactions",
        icon: "ft-layers",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "gmarket",
    title: "G Market",
    icon: "ft-shopping-cart", // alternative to shopping-cart
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "gmarketuser",
        title: "G Market User",
        icon: "ft-user", // single user
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "provincecommune",
        title: "Province & Commune",
        icon: "ft-map", // broader than pin, good for areas
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "category",
        title: "Category",
        icon: "ft-layers", // logical for categories
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "products",
        title: "Products",
        icon: "ft-box", // instead of package, clean alternative
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "orders",
        title: "Orders",
        icon: "ft-list", // order list
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "claim-requests",
        title: "Claim Requests",
        icon: "ft-alert-triangle", // claim/alert icon
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "gevent",
    title: "G Event",
    icon: "ft-layers",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "gevent-ticket-type",
        title: "Ticket Type",
        icon: "ft-layers",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gevent-events",
        title: "G-events",
        icon: "ft-calendar",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gevent-wallet-history",
        title: "Wallet Transaction",
        icon: "ft-list",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "gevent-reminder-settings",
        title: "Settings",
        icon: "ft-settings",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "userchannels",
    title: "User Channels",
    icon: "ft-instagram",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "userchannels",
        title: "Active Channels",
        icon: "ft-plus-circle",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "blockedchannels",
        title: "Blocked Channels",
        icon: "ft-info",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "channelmanager",
    title: "Admin Channels",
    icon: "ft-instagram",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "newadminchannel",
        title: "Add New",
        icon: "ft-plus-circle",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "channelmanager",
        title: "Show All",
        icon: "ft-info",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "admin-broadcast",
    title: "Admin Broadcast",
    icon: "ft-radio",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "adminmanagement",
    title: "Admin Management",
    icon: "ft-lock",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "badge",
    title: "Badge Settings",
    icon: "ft-shield",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "badge",
        title: "Badge",
        icon: "ft-tag",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "badgepackage",
        title: "Badge Packages",
        icon: "ft-package",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  {
    path: "profile",
    title: "Profile",
    icon: "ft-edit",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "generalsettings",
    title: "Site Settings",
    icon: "ft-settings",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "commissions",
    title: "Commission Settings",
    icon: "ft-settings",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "commissions/add",
        title: "Add Commission",
        icon: "ft-settings",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "commissions/withdraw",
        title: "Withdraw Commission",
        icon: "ft-settings",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "transfercommissions",
        title: "Transfer Commission",
        icon: "ft-settings",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },

  // {
  //   path: "commissions",
  //   title: "Commission Settings",
  //   icon: "ft-settings",
  //   class: "",
  //   badge: "",
  //   badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
  //   isExternalLink: false,
  //   submenu: [],
  // },

  {
    path: "appsettings",
    title: "App Update",
    icon: "ft-smartphone",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "banners",
    title: "Site Images",
    icon: "ft-home",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "notificationmanager",
    title: "Notification",
    icon: "ft-bell",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "announcement",
    title: "Announcement",
    icon: "ft-alert-circle",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },

  {
    path: "seomanager",
    title: "SEO",
    icon: "ft-trending-up",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "bancobu_transaction",
    title: "Bancobu Transaction",
    icon: "ft-trending-up",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "wallethistory/all",
    title: "Wallet Transaction",
    icon: "ft-trending-up",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "wallethistory/pending",
    title: "Pending Withdrawels",
    icon: "ft-trending-up",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "total_transaction",
    title: "Total Wallet",
    icon: "ft-trending-up",
    class: "",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [],
  },
  {
    path: "helpterms",
    title: "Help & Terms",
    icon: "ft-help-circle",
    class: "has-sub",
    badge: "",
    badgeClass: "badge badge-pill badge-danger float-right mr-1 mt-1",
    isExternalLink: false,
    submenu: [
      {
        path: "newhelpterms",
        title: "Add New",
        icon: "ft-plus-circle",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
      {
        path: "helpterms",
        title: "Show All",
        icon: "ft-info",
        class: "",
        badge: "",
        badgeClass: "",
        isExternalLink: false,
        submenu: [],
      },
    ],
  },
];
